export default "__VITE_ASSET__1d8feed3__"